export const TABLE_PAGE_HEADER = 'Videos Shared';
